import type { PromptImage } from './prompt'

export interface User {
  id: string
  name: string
  username?: string
  avatar: string
  bio?: string
  website?: string
  twitter?: string
  discord?: string
  instagram?: string
  facebook?: string
  github?: string
  tiktok?: string
  pinterest?: string
  linkedin?: string
  youtube?: string
  isAdmin?: boolean
  createdAt: string
  updatedAt?: string
}

export interface UserMinified {
  id: string
  name: string
  avatar: string
  username: string
}

export interface UserCreate {
  name: string
  avatar: string
  email: string
}

export interface UserUpdate {
  username?: string
  name?: string
  avatar?: string
  bio?: string
  website?: string
  twitter?: string
  discord?: string
  instagram?: string
  facebook?: string
  github?: string
  tiktok?: string
  pinterest?: string
  linkedin?: string
  youtube?: string
}

export interface UserProfile {
  id: string
  name: string
  username?: string
  avatar: string
  bio?: string
  created_at?: string
  isFollowed?: boolean
  nFollowees?: number
  nFollowers?: number
  nPrompts?: number
  nSaved?: number
  nUsed?: number
  nUses?: number
  avgRating?: number

  // Amount of prompts the user voted
  nVoted?: number

  // Amount of votes the user received
  nVotes?: number
  socialLinks?: {
    website?: string
    twitter?: string
    discord?: string
    instagram?: string
    facebook?: string
    github?: string
    tiktok?: string
    pinterest?: string
    linkedin?: string
    youtube?: string
  }
}

export interface PromptVote {
  userId: string
  promptId: string
}

export interface PromptTopic {
  userId: string
  promptId: string
}

export interface PromptUse {
  userId: string
  promptId: string
  input: string
}

export interface PromptSave {
  userId: string
  promptId: string
}

export interface FollowTopic {
  userId: string
  authorId: string
}

export interface FollowUser {
  followerId: string
  followeeId: string
}

export type SocialMedia = (typeof SOCIAL_MEDIAS)[number]

export interface UserInformation {
  id: string
  isFollowed: boolean
}

export enum RecentItemActionEnum {
  Edit = 'edit',
  Feed = 'feed',
  Public = 'public',
  View = 'view',
}
export interface RecentItem {
  createdAt: string
  updatedAt: string
  user: User
  title: string
  id: string
  isList: boolean
  description: string
  priceoriginal: number
  url: string
  images: {
    output: PromptImage[]
    cover: PromptImage[]
  }
  topicIds?: number[]
  typeId: number
  typeName: string
  attachments: File[]
  nVotes: number
  nUses: number
  nSaves: number
  isPrivate: boolean
  isVoted: boolean
  isSaved: boolean
  isFavorite: boolean
  isPremium: boolean
  isTutorialHidden: boolean
  isLocked: boolean
  nUserUses: number
  id_list: number
  recentItemCreatedAt?: string
  userId: string
  nPrompts: number
  elementalTypeId: number
  recentItemAction: RecentItemActionEnum
}

export interface FavoritedItem {
  createdAt: string
  updatedAt: string
  user: User
  title: string
  id: string
  isList: boolean
  description: string
  elementalTypeId: number
  url: string
  images: {
    output: PromptImage[]
    cover: PromptImage[]
  }
  topicIds?: number[]
  typeId: number
  typeName: string
  attachments: File[]
  nVotes: number
  nUses: number
  nSaves: number
  isPrivate: boolean
  isVoted: boolean
  isSaved: boolean
  isFavorite: boolean
  isPremium: boolean
  isTutorialHidden: boolean
  isLocked: boolean
  nUserUses: number
  id_list: number
}
